export default "__VITE_ASSET__BEpVXsix__"